// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wxvy","col":"styles_col__3aWAm"};